import "./OrderStatusSelector.css";

interface OrderStatusSelectorProps {
  value: string;
  action: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const OrderStatusSelector = ({
  value,
  action,
}: OrderStatusSelectorProps) => {
  return (
    <div className="order-status-selector">
      <label
        htmlFor="status-paid"
        className={`order-status-selector-item${
          value === "PAID" ? "-active" : ""
        }`}
      >
        Оплаченные
        <input
          type="radio"
          name="status"
          id="status-paid"
          value="PAID"
          onChange={action}
          checked={value === "PAID"}
        />
      </label>
      <label
        htmlFor="status-new"
        className={`order-status-selector-item${
          value === "NEW" ? "-active" : ""
        }`}
      >
        Новые
        <input
          type="radio"
          name="status"
          id="status-new"
          value="NEW"
          onChange={action}
          checked={value === "NEW"}
        />
      </label>
      <label
        htmlFor="status-pend-pay"
        className={`order-status-selector-item${
          value === "PENDING_PAYMENT" ? "-active" : ""
        }`}
      >
        Ожидают оплаты
        <input
          type="radio"
          name="status"
          id="status-pend-pay"
          value="PENDING_PAYMENT"
          onChange={action}
          checked={value === "PENDING_PAYMENT"}
        />
      </label>
      <label
        htmlFor="status-shipped"
        className={`order-status-selector-item${
          value === "SHIPPED" ? "-active" : ""
        }`}
      >
        В сборке
        <input
          type="radio"
          name="status"
          id="status-shipped"
          value="SHIPPED"
          onChange={action}
          checked={value === "SHIPPED"}
        />
      </label>
      <label
        htmlFor="status-deliver"
        className={`order-status-selector-item${
          value === "DELIVERED" ? "-active" : ""
        }`}
      >
        Доставляется
        <input
          type="radio"
          name="status"
          id="status-deliver"
          value="DELIVERED"
          onChange={action}
          checked={value === "DELIVERED"}
        />
      </label>
      <label
        htmlFor="status-done"
        className={`order-status-selector-item${
          value === "DONE" ? "-active" : ""
        }`}
      >
        Завершенные
        <input
          type="radio"
          name="status"
          id="status-done"
          value="DONE"
          onChange={action}
          checked={value === "DONE"}
        />
      </label>
      <label
        htmlFor="status-cancel"
        className={`order-status-selector-item${
          value === "CANCELLED" ? "-active" : ""
        }`}
      >
        Отмененные
        <input
          type="radio"
          name="status"
          id="status-cancel"
          value="CANCELLED"
          onChange={action}
          checked={value === "CANCELLED"}
        />
      </label>
    </div>
  );
};
